import { SharedModule } from '../../shared/shared.module';
import { DocumentsComponent } from './documents.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DocumentsMecenatModule } from './documents_mecenat_enterprise/documents-mecenat.module';

@NgModule({
  imports: [NgbModule, SharedModule, DocumentsMecenatModule],
  declarations: [DocumentsComponent],
  exports: [DocumentsComponent]
})
export class DocumentsModule {}
